/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Card, CardActions, CardContent, CardMedia, Button } from '@material-ui/core';
import { insertAt, getDotPosition, getStorageRef, getDocumentRef } from 'utils';
import { Loader, ViewDetails, AlertDialog, CustomButtonRed } from 'components';
import EditDetails from './Components/EditDetails/EditDetails';
import EditAvailability from './Components/EditAvailability/EditAvailability';

const useStyles = makeStyles((theme) => createStyles({
    root: {
      maxWidth: 500,
      minWidth: 345,
      backgroundColor: theme.palette.action.disabledBackground
    },
    media: {
      height: 250,
      minHeight: 250
    },
    cardContent: { padding: 8 }
  }));

export default function EditMediaCard({ data, handleOpenCarousel, index }) {
  const classes = useStyles();
  const { available, price, name, format, id, tehnique, booked, image, discount } = data;
  const { src, filename, resized } = image;

  const [resizedUrl, setResizedUrl] = useState('');

  const [newName, setNewName] = useState(name || '');
  const [newPrice, setNewPrice] = useState(price || null);
  const [newDiscount, setNewDiscount] = useState(discount || null);
  const [newTehnique, setNewTehnique] = useState(tehnique || '');
  const [newFormat, setNewFormat] = useState(format || '');

  const [isAvailable, setAvailable] = useState(available);
  const [isBooked, setBooked] = useState(booked || false);
  const [isEditMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpened, setIsOpened] = useState(false);

  const handleEditMode = () => setEditMode(true);
  const handleChangeName = (e) => setNewName(e.target.value);
  const handleChangeTehnique = (e) => setNewTehnique(e.target.value);
  const handleChangeFormat = (e) => setNewFormat(e.target.value);

  const handleChangePrice = (e) => {
    const value = parseInt(e.target.value);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) {
      setNewPrice(null);
    } else setNewPrice(value);
  };

  const handleChangeDiscount = (e) => {
    const value = parseInt(e.target.value);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) {
      setNewDiscount(null);
    } else setNewDiscount(value);
  };

  const handleChangeAvailability = (value) => setAvailable(value);
  const handleChangeBooked = (value) => setBooked(value);

  const handleCancelEdit = () => {
    setNewName(name);
    setNewFormat(format);
    setNewPrice(price);
    setAvailable(available);
    setEditMode(false);
  };

  const deleteDocument = () => {
    const ref = getDocumentRef(id, 'gallery');
    ref
      .delete()
      // .then(() => {
      //   displayMessage('Image Was Deleted!', 'success');
      // })
      .catch((error) => {
        console.log(error);
        // displayMessage(error.message, 'error');
      });
  };

  const updateDocument = () => {
    setIsLoading(true);
    const ref = getDocumentRef(id, 'gallery');
    ref
      .update({
        name: newName,
        price: newPrice,
        format: newFormat,
        available: isAvailable,
        tehnique: newTehnique,
        booked: isBooked,
        discount: newDiscount
      })
      .then(() => {
        setEditMode(false);
        setIsLoading(false);
        setIsOpened(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setIsOpened(false);
      });
  };

  useEffect(() => {
    const updateImageSrc = () => {
      if (resizedUrl && !resized && !src.includes('_800x800')) {
        const ref = getDocumentRef(id, 'gallery');
        ref
          .update({
            'image.src': resizedUrl,
            'image.resized': true
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };

    const getImage = () => {
      const resizedImage = insertAt(filename, '_800x800', getDotPosition(filename));
      const ref = getStorageRef(`gallery/${resizedImage}`);
      ref
        .getDownloadURL()
        .then((url) => {
          setResizedUrl(url);
        })
        .catch((error) => {
          // TODO: Display Error Snack
          console.log(error);
        });
    };
    if (!resizedUrl && !src.includes('_800x800')) {
      getImage();
    } else {
      updateImageSrc();
    }
  }, [resizedUrl, filename, src, id, resized]);

  const isDataChanged =
    newName !== name ||
    newFormat !== format ||
    newPrice !== price ||
    isAvailable !== available ||
    isBooked !== booked ||
    newTehnique !== tehnique ||
    newDiscount !== discount;

  return (
    <Card className={classes.root}>
      <Loader isLoading={isLoading} />
      {src.includes('_800x800') ? (
        <CardMedia
          onClick={() => handleOpenCarousel(index)}
          className={classes.media}
          image={src}
          title={name}
        />
      ) : (
        <Loader isLoading={true} />
      )}
      <CardContent className={classes.cardContent}>
        {isEditMode ? (
          <EditDetails
            name={newName}
            price={newPrice}
            format={newFormat}
            discount={newDiscount}
            tehnique={newTehnique}
            handleChangeName={handleChangeName}
            handleChangePrice={handleChangePrice}
            handleChangeFormat={handleChangeFormat}
            handleChangeTehnique={handleChangeTehnique}
            handleChangeDiscount={handleChangeDiscount}
          />
        ) : (
          <ViewDetails
            name={newName}
            price={newPrice}
            format={newFormat}
            tehnique={tehnique}
            discount={newDiscount}
          />
        )}
        <EditAvailability
          booked={isBooked}
          isEditMode={isEditMode}
          available={isAvailable}
          setBooked={handleChangeBooked}
          setAvailable={handleChangeAvailability}
        />
      </CardContent>
      <CardActions style={{ alignItems: 'center', justifyContent: 'center' }}>
        {!isEditMode ? (
          <>
            <Button onClick={handleEditMode} color="secondary" variant="contained">
              Editeaza
            </Button>
            <CustomButtonRed title="Sterge" handleClick={() => setIsOpened(true)} />
          </>
        ) : (
          <>
            <Button onClick={handleCancelEdit} color="primary" variant="contained">
              Anulează
            </Button>
            <Button disabled={!isDataChanged} onClick={updateDocument} color="secondary" variant="contained">
              Salveaza pe Server
            </Button>
          </>
        )}
      </CardActions>
      <AlertDialog
        open={isOpened}
        yesButtonText="Sterge"
        yesAction={deleteDocument}
        alertTitle="Sterge Document"
        cancelButtonText="Anulează"
        cancelAction={() => setIsOpened(false)}
        message="Documentul va fi sters definitiv!"
      />
    </Card>
  );
}
